import { createSlice } from "@reduxjs/toolkit";
import { AddDesignation, UpdateDesignation, GetDesignationList } from "services/other/designation.service";
import { toast } from 'react-toastify';

export const designationAddSlice = createSlice({
  name: "designationAdd",
  initialState: {
    designationAdd: {},
    designationAddLoading: false,
    designationAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddDesignation.pending, (state) => {
      // toast.loading('We are adding the designation 🤯')
      state.designationAddLoading = true
    });

    builder.addCase(AddDesignation.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New designation added successfully 👌');

      state.designationAdd = action.payload
      state.designationAddLoading = false
      state.designationAddError = null
    });

    builder.addCase(AddDesignation.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the designation 😣")

      state.designationAddLoading = false
      state.designationAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const designationUpdateSlice = createSlice({
  name: "designationUpdate",
  initialState: {
    designationUpdate: {},
    designationUpdateLoading: false,
    designationUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateDesignation.pending, (state) => {
      // toast.loading('We are updating the designation 🤯')
      state.designationUpdateLoading = true
    });

    builder.addCase(UpdateDesignation.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.designationUpdate = action.payload
      state.designationUpdateLoading = false
      state.designationUpdateError = null
    });

    builder.addCase(UpdateDesignation.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the designation 😣")

      state.designationUpdateLoading = false
      state.designationUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const designationListSlice = createSlice({
  name: "designationList",
  initialState: {
    designationList: [],
    designationListLoading: false,
    designationListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetDesignationList.pending, (state) => {
      state.designationListLoading = true
    });

    builder.addCase(GetDesignationList.fulfilled, (state, action) => {
      toast.dismiss();

      state.designationList = action.payload
      state.designationListLoading = false
      state.designationListError = null
    });

    builder.addCase(GetDesignationList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the designation 😣")

      state.designationListLoading = false
      // state.designationListError = action.error?.message
      // toast.error(action.error?.message)

    });
  },
});